import { render, staticRenderFns } from "./PlaceHolder.vue?vue&type=template&id=8a1c342a&"
import script from "./PlaceHolder.vue?vue&type=script&lang=js&"
export * from "./PlaceHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports